<template>
  <div class="col-md-6">
    <div
        class="alert alert-danger product-item__content--edit__error"
        role="alert"
        v-if="errors.length > 0"
      >
        <p v-for="error in errors" :key="error">{{error}}</p>
      </div>
    <div class="product-item">
      <h2 class="product-item__title">{{type}}</h2>
      <div v-if="editFlag" class="product-item__content--edit">
        <input :type="getInputType()" v-model="inputVal"  class="form-control">
        <button class="btn btn-primary" @click="editProduct(editProperty)"><i class="fas fa-check"></i></button>
      </div>
      <div v-else class="product-item__content">
        <p>{{inputVal}}</p>
        <button class="btn btn-dark" @click="toggleFunc()"><i class="far fa-edit"></i></button>
      </div>
    </div>
  </div>
</template>
<script>
import { herokuUrl } from "../../apiConfig";
import axios from "axios";
import { getCookie } from "../../cookie.js";
import logOut from "../../scripts/utils";

export default {
  props: ["name", "type", 'editProperty', 'productId', 'meta', 'product'],
  	data() {
		return {
			editFlag: false,
			loading: false,
      errors: [],
      inputVal: this.name
		}
	},
  methods: {
    getInputType() {
      return this.$props.type == "Price Sale" || this.$props.type == "Price"
        ? "number"
        : "text";
    },
    toggleFunc(){
      this.editFlag = !this.editFlag;
    },
    c2method: function(product){
      // importing changeCurrentProduct function
     this.$root.$emit('component1', product); //like this
    },
    editProduct(property) {
      this.errors = [];
      let key;
      if (property !=  "sale_price" && this.inputVal == null) {
        return this.errors.push("Enter a value in field to update");
      }
      if (property !=  "sale_price" && this.inputVal.length === 0) {
        return this.errors.push("Enter a value in field to update");
      }
      if(property!='sub_title' && property!='sub_title_en' && property!='sku' && property !=  "sale_price" && property !=  "price") {
        if (
          this.inputVal.length < 3 ||
          this.inputVal.length > 50
        ) {
          this.errors.push("this field should be between 3 and 50 characters.");
        }
      }

      if((property =='sub_title' || property=='sub_title_en') && (this.inputVal.length < 3 || this.inputVal.length > 350) ){
          this.errors.push("this field should be between 3 and 350 characters.");
      }

      property === "sale_price" ? (key = "price_discount") : (key = property);

      (property == "price") && (this.inputVal <= 0)
        ? this.errors.push("Price cannot be 0 or less.")
        : 1;
       (property == "sale_price") && (this.inputVal!= "" ) && (this.inputVal <= 0)
        ? this.errors.push("Sale price cannot be 0 or less.")
        : 1;

      (property == "price") && (this.inputVal < this.$props.product.sale_price)
        ? this.errors.push("Price cannot be less than Sale price")
        : 1;
      (property == "sale_price") && (this.inputVal > this.$props.product.price)
        ? this.errors.push("Sale price cannot more than the price.")
        : 1;

      if (this.errors.length === 0) {
        if (property == "price")
          this.$props.product.price = this.inputVal;
        else if (property == "sale_price")
          this.$props.product.sale_price = this.inputVal;
        axios
          .post(
            `${herokuUrl}/dashboard/edit-product`,
            {
              productId: this.productId,
              [key]: this.inputVal,
              meta: this.meta ? key : false
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: getCookie("user")
              }
            }
          )
          .then(response => {
            if (response.data.status) {
              this.editFlag = false;
              console.log(this.$props.editProperty)
              if(this.$props.editProperty == "sale_price" || this.$props.editProperty == "price"){
                // this.$router.replace({ path: 'manage-product', query: { selectedOrderId:  this.productId} })
                // window.location.replace(window.location.origin + "/manage-product?selectedOrderId=" + this.productId);
                this.c2method(this.$props.product);
              }
            } else {
              console.log('else')
              console.log(response)
              if(response.data.message)
              this.errors.push(response.data.message);
              else
              this.errors.push("For files, large file upload is forbidden");
              this.errors.push(
                ...response.data.error.errors.map(er => er.message)
              );
            }
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              console.log('catch')
              this.errors.push(err);
              this.errors.push("For files, large file upload is forbidden");
            }
          });
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.product-item {
  margin-bottom: 18px;
  &__title {
    font-size: 18px;
    background: #ccc;
    padding: 5px;
    border-radius: 10px;
  }
  &__content,
  &__content--edit {
    display: flex;
    justify-content: space-between;
    p {
      flex: 1;
      text-align: left;
      padding-left: 12px;
    }
  }
  &__content {
    button {
      align-self: flex-start;
    }
  }
}
</style>

